import {isEqual, isFunction, isObject, keys, union} from 'lodash';
import React from 'react';

function isRequiredUpdateObject(o) {
  return (
    Array.isArray(o) || (o && o.constructor === Object.prototype.constructor)
  );
}

function deepDiff(o1, o2, p) {
  const notify = (status) => {
    console.warn('Update %s', status);
    console.log('%cbefore', 'font-weight: bold', o1);
    console.log('%cafter ', 'font-weight: bold', o2);
  };
  if (!isEqual(o1, o2)) {
    console.group(p);
    if ([o1, o2].every(isFunction)) {
      notify('avoidable?');
    } else if (![o1, o2].every(isRequiredUpdateObject)) {
      notify('required.');
    } else {
      const objKeys = union(keys(o1), keys(o2));
      if (objKeys) {
        objKeys.forEach((key) => deepDiff(o1[key], o2[key], key));
      }
    }
    console.groupEnd();
  } else if (o1 !== o2) {
    console.group(p);
    notify('avoidable!');
    if (isObject(o1) && isObject(o2)) {
      const objKeys = union(keys(o1), keys(o2));
      if (objKeys) {
        objKeys.forEach((key) => deepDiff(o1[key], o2[key], key));
      }
    }
    console.groupEnd();
  }
}

/* eslint-disable react/display-name */
const WhyDidYouUpdate = (ComposedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        seconds: 0,
      };
    }

    componentDidUpdate(prevProps, prevState) {
      deepDiff(
        {props: prevProps, state: prevState},
        {props: this.props, state: this.state},
        ComposedComponent.displayName || ComposedComponent.name
      );
    }

    render() {
      return <ComposedComponent {...this.props} {...this.state} />;
    }
  };
/* eslint-enable react/display-name */

WhyDidYouUpdate.displayName = 'WhyDidYouUpdate';

export default WhyDidYouUpdate;
